import React from "react";
import { useLeague } from "context/leagueContext";
import { useRound } from "context/roundContext";
import { classNames } from "utils/utils";

const RoundResults = ({ isLoading }) => {
  const {
    state: { leagueInfo },
  } = useLeague();
  const {
    state: { currentRound, roundEvents, userRoundData },
  } = useRound();

  let eventPoints = userRoundData?.points;
  let totalPoints = userRoundData?.points;
  let bonusPoints = 0;

  if (userRoundData?.allDrawBonus) {
    bonusPoints = bonusPoints + userRoundData?.allDrawBonus;
    eventPoints = eventPoints - userRoundData?.allDrawBonus;
  }
  if (userRoundData?.allWinBonus) {
    bonusPoints = bonusPoints + userRoundData?.allWinBonus;
    eventPoints = eventPoints - userRoundData?.allWinBonus;
  }

  return userRoundData?.points > 0 ? (
    <>
      <div className="block uppercase tracking-wide text-xs mb-1 pl-2 text-textPrimary">
        My score
      </div>
      <div className="rounded-md bg-white mb-4">
        <div className="flex w-full flex-col ">
          <div className="flex w-full justify-evenly py-2 space-y-0 flex-row ">
            <div className="flex flex-col justify-center items-center">
              <div className="block uppercase tracking-wide text-secondary700 text-xs">
                Points
              </div>

              <div className="flex justify-center">
                {isLoading ? (
                  <div className="h-4 w-8 mt-2 mb-1 rounded-md bg-gray-200 animate-pulse"></div>
                ) : (
                  <div className="flex mt-1 justify-center ">
                    {leagueInfo?.scoreRule == 2
                      ? eventPoints.toFixed(2) + "p"
                      : eventPoints + "p"}
                  </div>
                )}
              </div>
            </div>
            <div className="flex flex-col justify-center items-center">
              <div className="block uppercase tracking-wide text-secondary700 text-xs">
                Correct
              </div>

              <div className="flex justify-center">
                {isLoading ? (
                  <div className="h-4 w-8 mt-2 rounded-md bg-gray-200 animate-pulse"></div>
                ) : (
                  <div className="flex mt-1 justify-center ">
                    {userRoundData?.correct ? userRoundData?.correct : 0}/
                    {roundEvents?.length}{" "}
                    {userRoundData?.correct == roundEvents?.length ? "💥" : ""}
                  </div>
                )}
              </div>
            </div>
            <div className="flex flex-col justify-center items-center ">
              <div className="block uppercase tracking-wide text-secondary700 text-xs">
                Bonus
              </div>

              <div className="flex justify-center ">
                {isLoading ? (
                  <div className="h-4 w-8 mt-2 rounded-md bg-gray-200 animate-pulse"></div>
                ) : (
                  <div
                    className={classNames(
                      currentRound?.settled ? "" : "italic text-secondary500",

                      "flex mt-1 justify-center"
                    )}
                  >
                    {bonusPoints}p
                  </div>
                )}
              </div>
            </div>

            <div className="flex flex-col justify-center items-center ">
              <div className="block uppercase tracking-wide text-secondary700 text-xs">
                Total
              </div>

              <div className="flex justify-center ">
                {isLoading ? (
                  <div className="h-4 w-8 mt-2 rounded-md bg-gray-200 animate-pulse"></div>
                ) : (
                  <div
                    className={classNames(
                      currentRound?.settled
                        ? ""
                        : "italic text-secondary500 animate-pulse",

                      "flex mt-1 justify-center"
                    )}
                  >
                    {leagueInfo?.scoreRule == 2
                      ? totalPoints.toFixed(2) + "p"
                      : totalPoints + "p"}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  ) : (
    <></>
  );
};

export default RoundResults;
